'use client';

import { create } from 'zustand';

export type ActiveFlyout = 'menu' | 'account' | null;

type FlyoutSource = Exclude<ActiveFlyout, null>;

type HeaderFlyoutStore = {
    activeFlyout: ActiveFlyout;
    setFlyoutOpen: (source: FlyoutSource, open: boolean) => void;
};

export const useHeaderFlyoutStore = create<HeaderFlyoutStore>(set => ({
    activeFlyout: null,
    setFlyoutOpen: (source, open) => {
        set(state => {
            if (open) return { activeFlyout: source };
            if (state.activeFlyout === source) return { activeFlyout: null };
            return state;
        });
    },
}));
